export const getKeywordFilterLabel = (keyword: string, type: string): string => {
  return `${type}: ${keyword}`;
};

export const getKeywordFilterValue = (keyword: string, type: string): string => {
  return `${keyword} - ${type}`;
};
